const appendStyles = (...args) => {
    return [...args].join(' ');
}

export { appendStyles };